import { type IServerResponse } from './index'

const printLog = async (response: IServerResponse): Promise<void> => {
  if (process.env.NODE_ENV === 'production') return

  const { default: queryString } = await import('query-string')

  const url = queryString.stringifyUrl(
    {
      url: response.config.url ?? '',
      query: response.config?.params
    },
    {
      arrayFormat: 'bracket'
    }
  )

  console.groupCollapsed(
    `Server: [${response.status}] ${
      response.config.method?.toUpperCase() ?? ''
    } ${url}`
  )

  console.groupCollapsed('Response')
  console.log(response.data)
  console.groupEnd()

  console.groupCollapsed('Request (data)')
  console.log(response.config.data)
  console.groupEnd()

  console.groupCollapsed('Request')
  console.log(response.config)
  console.groupEnd()

  console.groupEnd()
}

export { printLog }
